module.exports = __webpack_public_path__ + "img/petronas-white.eb0df2f3.svg";